<template>
  <div class="page-img01">
    <div class="back-area" @click="$router.go(-1)"></div>
    <div class="img-container">
      <img src="@/assets/imgs/1.jpg" alt="图片展示" class="display-img" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageImg01'
}
</script>

<style scoped>
.page-img01 {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.back-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
  cursor: pointer;
  z-index: 10;
}

.img-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.display-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
